import { paddingClass, TStyleBoolOrSize } from "../Style";
import { IColumnConfig } from "./types";

export const getColumnStyle = ({ flexGrow = 0, width = "0px", minWidth = "0px", maxWidth }: IColumnConfig) => ({
  flex: `${flexGrow} 1 auto`,
  width,
  maxWidth,
  minWidth,
});

export const getRowPadding = (rowPadding?: TStyleBoolOrSize) => (rowPadding ? paddingClass([false, rowPadding]) : null);
